import { Routes } from "@angular/router";

export const SECURITY_CHILD_ROUTES: Routes = [
  {
    path: 'general',
    children: [
      {
        path: "",
        redirectTo: 'ssl',
        pathMatch: 'full'
      },
      {
        path: 'ssl',
        loadComponent: () => import('../general/ssl/ssl.component').then((c) => c.SslComponent)
      },
      {
        path: 'safeguards',
        loadComponent: () => import('../general/safeguards/safeguards.component').then((c) => c.SafeguardsComponent)
      },
      {
        path: 'truststore',
        loadComponent: () => import('../general/truststore/truststore.component').then((c) => c.TruststoreComponent)
      }
    ]
  },
  {
    path: 'auth',
    children: [
      {
        path: "",
        redirectTo: 'provider',
        pathMatch: 'full'
      },
      {
        path: 'provider',
        loadComponent: () => import('../authentication/security-providers/security-providers.component').then((c) => c.SecurityProvidersComponent)
      },
      {
        path: 'roleconfig',
        loadComponent: () => import('../authentication/login-config/login-config.component').then((c) => c.LoginConfigComponent)
      },
      {
        path: 'csrf',
        loadComponent: () => import('../authentication/csrf/csrf.component').then((c) => c.CsrfComponent)
      },
      {
        path: 'roles',
        loadComponent: () => import('../authorization/app-roles/app-roles.component').then((c) => c.AppRolesComponent)
      },
      {
        path: 'web',
        loadComponent: () => import('../authorization/pages/pages.component').then((c) => c.PagesComponent)
      },
      {
        path: 'services',
        loadComponent: () => import('../authorization/services/services.component').then((c) => c.ServicesComponent)
      },
      {
        path: 'prefabs',
        loadComponent: () => import('../authorization/prefabs/prefabs.component').then((c) => c.PrefabsComponent)
      }
    ]
  }
];
